import React, { Component } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { Flex, Box } from 'grid-styled';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Link } from 'react-router-dom';

import Page from './Page';
import connect from '../store/connect';
import { dynamicFontSize, fontFamilyHeading } from '../styles/helpers/mixins';
import MainProductImage from '../components/MainProductImage';
import { fetchArticlePageView, fetchBrandData, fetchDesignerData } from '../actions/actionCreators';
import { ProductImage } from '../styles/ProductImage';
import { color, animation, size } from '../styles/helpers/variables';
import { Container } from '../styles/Container';
import { Heading } from '../styles/Heading';
import { Preamble } from '../styles/Preamble';
import LinedHeading from '../components/LinedHeading';
import { SITE_ROOT_URL } from '../constants/endpoints';
import ErrorPage from './ErrorPage';
import NotFoundPage from "./NotFoundPage";
import { isTouchDevice } from "../util/isTouchDevice";

class BrandListPage extends Component {
  constructor(props) {
    super(props);

    this.spans = [];
    this.specialCharacterCategory = '#';
    this.alphabetArray = [
      this.specialCharacterCategory,
      ...[...Array(26)].map((q, w) => String.fromCharCode(w + 97).toUpperCase()),
      'Å',
      'Ä',
      'Ö'
    ];

    this.state = {
      searchString: '',
      availableLetters: ''
    };
  }

  componentWillMount() {
    if (this.props.type === 'brands') {
      this.props.fetchBrandData();
    } else if (this.props.type === 'designers') {
      this.props.fetchDesignerData();
    }
    this.props.fetchArticlePageView({ urlPath: this.props.location.pathname });
  }

  componentDidMount() {
    if (!isTouchDevice()) {
      this.inputField.focus();
    }
  }
  
  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.match.path !== nextProps.match.path) {
      this.setState({ searchString: '' });
      this.inputField.value = '';
      if (!isTouchDevice()) {
        this.inputField.focus();
      }
      if (nextProps.type === 'brands') {
        nextProps.fetchBrandData();
      } else if (nextProps.type === 'designers') {
        nextProps.fetchDesignerData();
      }
      nextProps.fetchArticlePageView({ urlPath: nextProps.location.pathname });
    }
  }
  
  brandSearchInputHandler(event) {
    this.setState({ searchString: event.target.value });
  }

  handleScrollToElement(id) {
    return e => {
      e.preventDefault();
      this[`lineHeadingRef${id}`].scrollIntoView({ block: 'start' });
    };
  }

  addSpanRef(node) {
    this.spans = [...this.spans, node];
  }

  renderBrandsLetters() {
    let availableLetters = '';
    const brandsLetters = this.props.brands
      .filter(
        x =>
          x
            .get('name')
            .toLowerCase()
            .indexOf(this.state.searchString.toLowerCase()) !== -1
      )
      .groupBy(
        item =>
          this.alphabetArray.includes(item.get('name').toUpperCase()[0])
            ? item.get('name').toLowerCase()[0]
            : this.specialCharacterCategory
      )
      .sortBy((item, index) => index)
      .map((item, index) => {
        const currentLetter = index;

        if (availableLetters.indexOf(currentLetter) === -1) {
          availableLetters += currentLetter;
        }

        return (
          /** adjustScroll and style with paddingTop: 35px: (ScrollRefElem), temporary solution for scrolling to correct pos. See handleScrollToElement */
          <ScrollRefElem
            key={`letter-section-${currentLetter}`}
            innerRef={x => {
              this[`lineHeadingRef${currentLetter}`] = x;
            }}
          >
            <LinedHeading adjustScroll smallestFontSizeBound={20} bgColor={color.lightGrey}>
              {currentLetter}
            </LinedHeading>
            <Flex flexWrap="wrap" mx={['-4px', '-6px', '-8px', '-12px']} mb={0}>
              {this.renderBrands(item)}
            </Flex>
          </ScrollRefElem>
        );
      })
      .toArray();

    if (this.state.availableLetters !== availableLetters) {
      this.setState({ availableLetters });
    }

    return brandsLetters;
  }

  renderBrands(brands) {
    return brands
      .sortBy(item => item.get('name').toLowerCase())
      .map(item => {
        return (
          <Box key={item.get('systemId')} width={[1 / 2, 1 / 3, 1 / 4, 1 / 5, 1 / 6]} p={['4px', '6px', '8px', '12px']}>
            <ProductCardLink to={item.get('url')}>
              <ProductCardContainer>
                <MainProductImage insideList round={this.props.endpoint === 'designers'}>
                  {item.getIn(['images', 0, 'url']) ? (
                    <ProductImage round={this.props.type === 'designers'} src={SITE_ROOT_URL + item.getIn(['images', 0, 'url'])} />
                  ) : (
                    false
                  )}
                </MainProductImage>
                <NameTag>{item.get('name')}</NameTag>
              </ProductCardContainer>
            </ProductCardLink>
          </Box>
        )
      })
      .toArray();
  }

  renderAlphabet() {
    return this.alphabetArray.map(item => {
      const disabled = !(this.state.availableLetters.indexOf(item.toLowerCase()) !== -1);
      return (
        <ListItem key={`alphabet-${item}`} disabled={disabled}>
          <button disabled={disabled} onClick={this.handleScrollToElement(item.toLowerCase())}>
            {item}
          </button>
        </ListItem>
      );
    });
  }

  render() {
    const { request } = this.props;
  
    if (request.get('statusCode') === 404) return <NotFoundPage />;
    if (request.get('status') === 'ERROR') return <ErrorPage />;
    
    const brandsList = this.renderBrandsLetters();
    const alphabet = this.renderAlphabet();

    return (
      <Page meta={this.props.currentPage.get('metaData')} bgColor={color.lightGrey}>
        <Container bgColor={color.lightGrey}>
          <Heading big center>
            {this.props.currentPage.getIn(['fields', 'title'])}
          </Heading>
          <Preamble>{this.props.currentPage.getIn(['fields', 'introduction'])}</Preamble>
          <BrandsInputContainer>
            <FilterBrandsInput
              innerRef={e => {
                this.inputField = e;
              }}
              onChange={event => {
                this.brandSearchInputHandler(event);
              }}
            />
            <SearchSvg />
          </BrandsInputContainer>
          <AlphabetList>{alphabet}</AlphabetList>
          <ThemeProvider
            theme={{
              breakpoints: ['40em', '53.125em', '68.75em', '99.625em']
            }}
          >
            <BrandsListContainer>{brandsList}</BrandsListContainer>
          </ThemeProvider>
        </Container>
      </Page>
    );
  }
}

const BrandsListContainer = styled.div`
  margin-bottom: 85px;
`;
const ScrollRefElem = styled.div`
  padding-top: 35px;
  &:first-child {
    padding-top: 0;
  }
`;
const BrandsInputContainer = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 600px;
`;
const SearchSvg = styled.span`
  position: absolute;
  top: 15px;
  right: 15px;
  display: inline-block;
  background-image: url(/images/icons/search-black.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 20px;
  height: 20px;
`;
const ProductCardContainer = styled.div`
  background-color: #fff;
  margin: 0;
  padding: 0 0 10px;
  position: relative;

  &:after {
    content: '';
    transition: opacity 0.4s ${animation.easing};
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;
const ProductCardLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  transition: opacity ${animation.transitionTime} ${animation.easing};

  &:hover {
    opacity: 0.8;
    ${ProductCardContainer}:after {
      opacity: 1;
    }
  }
`;

const NameTag = styled.p`
  background-color: ${color.white};
  line-height: 1.3;
  text-align: center;
  margin: 0;
  padding: 30px 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${fontFamilyHeading};

  ${props => props.disabled && css`
    opacity: .6;
  `}

  ${dynamicFontSize(14, 18)};
  @media screen and (min-width: ${size.medium}px) {
    ${dynamicFontSize(18, 20)};
  }
  @media screen and (min-width: 850px) {
    font-size: 20px;
  }
`;
const AlphabetList = styled.ul`
  list-style-type: none;
  display: block;
  text-align: center;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;
const ListItem = styled.li`
  transition: opacity 0.25s ease-out;
  display: block;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 5px;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.3;
    `};
  button {
    cursor: pointer;
    color: ${color.black};
    text-decoration: none;
    font-size: 16px;
    border: none;
    background-color: transparent;
    padding: 0;
    font-family: inherit;
    font-weight: 600;
    outline: 0;
    padding: 3px 7px;
    @media all and (hover: none) {
      padding: 5px 10px;
    }
  }
`;
const FilterBrandsInput = styled.input.attrs({
  type: 'text',
  placeholder: 'Sök...'
})`
  background-color: #ffffff;
  border: solid 1px ${color.darkgrey};
  color: ${color.black};
  outline: 0;
  font-size: 16px;
  font-weight: normal;
  padding: 16px 40px 16px 14px;
  width: 100%;
  max-width: 600px;
  display: block;
  margin: 25px 0 30px;
  -webkit-appearance: none;
  border-radius: 0;

  &::placeholder {
    color: ${color.black};
    font-style: italic;
  }
`;

BrandListPage.defaultProps = {
  brands: Map(),
  currentPage: Map(),
  request: Map(),
  endpoint: '',
};

BrandListPage.propTypes = {
  brands: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired,
  currentPage: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map),
  fetchArticlePageView: PropTypes.func.isRequired,
  fetchBrandData: PropTypes.func.isRequired,
  endpoint: PropTypes.string,
};

export default connect(
  BrandListPage,
  { fetchArticlePageView, fetchBrandData, fetchDesignerData },
  (store, props) => ({
    request: store.page.request.get(props.location.pathname),
    currentPage: store.page.data.get(props.location.pathname),
    brands: store[props.type],
  })
);



// WEBPACK FOOTER //
// ./src/pages/BrandListPage.js